/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Consent_LimitsInputs */

const en_mcp_connect_consent_limits = /** @type {(inputs: Mcp_Connect_Consent_LimitsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It can’t delete your documents or manage your subscription. You can disconnect Listening from ${i?.app} at any time.`)
};

const es_mcp_connect_consent_limits = /** @type {(inputs: Mcp_Connect_Consent_LimitsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No puede eliminar tus documentos ni gestionar tu suscripción. Puedes desconectar Listening de ${i?.app} en cualquier momento.`)
};

/**
* | output |
* | --- |
* | "It can’t delete your documents or manage your subscription. You can disconnect Listening from {app} at any time." |
*
* @param {Mcp_Connect_Consent_LimitsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_consent_limits = /** @type {((inputs: Mcp_Connect_Consent_LimitsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Consent_LimitsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_consent_limits(inputs)
	return en_mcp_connect_consent_limits(inputs)
});